import { useEffect } from "react";
import { Button } from "../../../components/ui";
import localization from "../../../config/localization";
import { userPendingStore } from "../../users/store/userPendingData.store";

interface VerificationTabsProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
}

export function VerificationTabs({
  activeTab,
  onTabChange,
}: VerificationTabsProps) {


  useEffect(() => {
    userPendingStore.getState().fetchPendingData();
  }, []);


  const tabs = [
    {
      id: "identification",
      label: localization.identification,
    },
    {
      id: "banking",
      label: localization.banking,
    },
  ];

  return (
    <div>
      <div className="flex space-x-10 px-7 pt-4 pb-2">
        {tabs.map((tab) => {
          const isActive = activeTab === tab.id;

          return (
            <div key={tab.id} className="shrink-0 flex rounded-lg">
              <Button
                onClick={() => onTabChange(tab.id)}
                className="flex flex-col items-center gap-1.5 min-w-[64px]"
              >
                <span
                  className={` font-medium ${
                    isActive ? "text-white" : "text-gray-400"
                    }`}
                >
                  {tab.label}
                </span>

                <span
                  className={`h-[2px] w-[120%] rounded-full transition-all duration-300 ${
                    isActive ? "bg-[#FF94B1]" : "bg-transparent"
                    }`}
                />
              </Button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
